export default {
  name: "Reductions-component",
  data() {
    return {
      isReady: false,
      reductions: []
    };
  },
  methods: {
    error() {
      this.$store.dispatch("logout");
      this.$router.push("/");
    },
    updateValue(val, id, redNumber) {
      const red = "red" + redNumber;
      this.reductions[id][red] = parseFloat(val.target.value);
      console.log(this.reductions);
    },
    updateReds() {
      const axios = require("axios");
      axios.post(this.$store.state.api_url + "/reductions", this.reductions, {
        headers: {
          Authorization: "Bearer " + this.$store.state.token
        }
      }).then(response => {
        console.log("Success :", response);
        //this.isbusy = false;
        this.$bvToast.toast("Modifié avec succée", {
          title: `Succée`,
          variant: "success",
          solid: true
        });
        // location.reload();
      }).catch(err => {
        if (err.response.status === 401) {
          console.log("uNauthorized request");
          console.log(err);
          this.error();
        } else {
          console.log("error : " + err);
          this.$bvToast.toast("Erreur", {
            variant: "danger",
            solid: true
          });
        }
      });
    }
  },
  mounted() {
    const axios = require("axios");
    axios.get(this.$store.state.api_url + "/reductions", {
      headers: {
        Authorization: "Bearer " + this.$store.state.token
      }
    }).then(response => {
      const data = response.data;
      this.reductions = data;
      this.isReady = true;
    }).catch(err => {
      if (err.response.status === 401) {
        console.log("uNauthorized request");
        console.log(err);
        this.error();
      } else {
        console.log("error : " + err);
      }
    });
  }
};